import script from "./CustomerBehavior.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBehavior.vue?vue&type=script&setup=true&lang=js"

import "./CustomerBehavior.vue?vue&type=style&index=0&id=3ead0da9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ead0da9"]])

export default __exports__